import React from 'react';
import { connect } from 'react-redux';
import { Wrapper, Item } from './styled';
import QuizAnswer from '~/src/components/QuizBlock/QuizAnswer';
import { hasProp } from '~/src/helpers/object';

const Answers = ({ stepQuiz, questions, onClickRadio, onClickCheckbox, isSended, isSendError }) => {

    if (questions.length === 0) {
 return null;
}

    const currentQuestion = questions[stepQuiz];

    const answers = (currentQuestion && currentQuestion.answers)
        ? currentQuestion.answers
        : false;

    if (!answers || isSended || isSendError) {
 return null;
}

    return (
        <Wrapper>
            {
                answers.map((answer, index) => {
                    return (
                        <Item key={index} quantity={answers.length}>
                            <QuizAnswer
                                borderWeight={2}
                                borderColor='#E0E0E0'
                                bgColor='rgba(255, 255, 255, 0.75)'
                                title={answer.title}
                                selected={hasProp(answer, 'selected') ? answer.selected : false}
                                index={index}
                                multiple={currentQuestion.multiple}
                                onClickHandler={() => currentQuestion.multiple ? onClickCheckbox(index) : onClickRadio(index)}
                            />
                        </Item>
                    );
                })
            }
        </Wrapper>
    );
};

Answers.defaultProps = {
    stepQuiz: 0,
    questions: [],
    onClickRadio: () => null,
    onClickCheckbox: () => null
};

const mapStateToProps = state => ({
    stepQuiz: state.quiz.stepQuiz,
    questions: state.quiz.questions,
    isSended: state.quiz.isSended,
    isSendError: state.quiz.isSendError
});

export default connect(mapStateToProps)(Answers);
